import ProductCard from '@/components/ProductCard'
import { ProductCardType } from '@/constants'
import type { Product } from '@/types'
import type { FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'

interface Props {
  relatedProductData: Product[]
}

export const RelatedProduct: FC<Props> = ({ relatedProductData }: Props) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    variableWidth: true,
    adaptiveHeight: true,
    swipeToSlide: true,
  }
  return (
    <section className='w-full px-3 border-b-8 pt-4 bg-white-400 border-gray-200 pb-5'>
      {relatedProductData && relatedProductData.length > 0 && (
        <>
          <h2 className='text-titleSection mb-3 text-left text-dark-400'>
            Sản phẩm liên quan
          </h2>
          <div className='related-product ml-[-10px] mr-[-12px] max-h-[340px] overflow-hidden'>
            {relatedProductData?.length > 2 ? (
              <Slider {...settings} className='max-w-screen flex w-full'>
                {relatedProductData &&
                  relatedProductData.map((product: Product) => (
                    <ProductCard
                      key={product._id}
                      product={product}
                      layout={2}
                      className='relatedProductSlider'
                      type={ProductCardType.RELATED}
                    />
                  ))}
              </Slider>
            ) : (
              <div className='max-w-screen grid grid-cols-2 gap-2 px-2'>
                {relatedProductData &&
                  relatedProductData.map((product: Product) => (
                    <ProductCard
                      key={product._id}
                      product={product}
                      layout={2}
                      className='relatedProductSlider !px-0'
                      type={ProductCardType.RELATED}
                    />
                  ))}
              </div>
            )}
          </div>
        </>
      )}
    </section>
  )
}
